import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { FormsModule } from '@angular/forms';

import { LoginComponent } from './login/login.component'

import { AuthRoutes } from './auth.routing';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ActivateAccountComponent } from './activate-account/activate-account.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { TranslateModule } from '@ngx-translate/core';
import {TooltipModule} from "ngx-bootstrap/tooltip";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TooltipModule.forRoot(),
        RouterModule.forChild(AuthRoutes),
        TranslateModule
    ],
    declarations: [
        LoginComponent,
        ResetPasswordComponent,
        ForgotPasswordComponent,
        ActivateAccountComponent,
        ChangePasswordComponent
    ]
})
export class AuthModule { }
